import React from "react";

const StatsReport = ({
    resolutionTypeOptions,
    metricFields,
    spreadsheetData,
}) => {
    const statsRows = Array.isArray(spreadsheetData?.rows)
        ? spreadsheetData.rows
        : [];

    const totalIncidents = statsRows.reduce(
        (sum, row) => sum + (Number(row?.incident_count) || 0),
        0
    );

    const totalResolved = statsRows.reduce(
        (sum, row) => sum + (Number(row?.resolved_count) || 0),
        0
    );

    // if this is the first page load for empty page
    //
    if (!spreadsheetData) {
        return (
            <div
                style={{
                    marginTop: "24px",
                    padding: "40px 24px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    background: "#fafafa",
                    textAlign: "center",
                    color: "#666",
                }}
            >
                <div
                    style={{
                        fontSize: "1.2rem",
                        fontWeight: 700,
                        color: "#333",
                        marginBottom: "8px",
                    }}
                >
                    Statistics
                </div>

                <div>
                    Choose your report filters above, then click Run Report
                    to view incident metrics.
                </div>
            </div>
        );
    }

    return (
        <div
            style={{
                marginTop: 20,
                background: "#fff",
                border: "1px solid #ccc",
                borderRadius: 8,
                overflow: "hidden",
            }}
        >
            {/* ------------------------------------------------------------ */}
            {/* UNRESOLVED INCIDENTS                                          */}
            {/* ------------------------------------------------------------ */}

            {Array.isArray(spreadsheetData?.unresolved) &&
                spreadsheetData.unresolved.length > 0 && (
                    <div
                        style={{
                            padding: "16px",
                            borderBottom: "1px solid #ccc",
                            background: "#fafafa",
                            marginBottom: "40px", // space before statistics table
                        }}
                    >
                        <div
                            style={{
                                fontWeight: 700,
                                fontSize: "1rem",
                                marginBottom: 10,
                                color: "#dc3545",
                            }}
                        >
                            Unresolved Incidents
                        </div>

                        <div
                            style={{
                                overflowX: "auto",
                                WebkitOverflowScrolling: "touch",
                            }}
                        >
                            <table
                                style={{
                                    borderCollapse: "collapse",
                                    width: "100%",
                                    minWidth: "700px",
                                    fontSize: "0.85rem",
                                }}
                            >
                                <thead>
                                    <tr>
                                        <th>Incident</th>
                                        <th>Date Received</th>
                                        <th>Incident Type</th>
                                        <th>Location</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {spreadsheetData.unresolved.map((incident) => (
                                        <tr key={incident.id}>
                                            <td>{incident.display_title}</td>
                                            <td>{incident.date_received}</td>
                                            <td>{incident.incident_type}</td>
                                            <td>{incident.location}</td>
                                            <td>{incident.status}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            {/* ------------------------------------------------------------ */}
            {/* STATISTIC-METRICS INCIDENTS                                  */}
            {/* ------------------------------------------------------------ */}

            <div
                style={{
                    overflowX: "auto",
                    WebkitOverflowScrolling: "touch",
                }}
            >
                <table
                    style={{
                        borderCollapse: "collapse",
                        minWidth: "1400px",
                        width: "100%",
                        fontSize: "0.75rem",
                    }}
                >
                    <thead>
                        <tr>
                            <th
                                className="stats-sticky-col"
                                style={{
                                    width: "130px",
                                    whiteSpace: "nowrap",
                                    verticalAlign: "middle",
                                    padding: "6px 8px",
                                }}
                            >
                                Period
                            </th>

                            <th
                                style={{
                                    width: "110px",
                                    whiteSpace: "normal",
                                    overflowWrap: "break-word",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                    padding: "6px 8px",
                                }}
                            >
                                Total Incidents
                            </th>

                            <th
                                style={{
                                    width: "125px",
                                    whiteSpace: "normal",
                                    overflowWrap: "break-word",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                    padding: "6px 8px",
                                }}
                            >
                                Resolved Incidents
                            </th>

                            {resolutionTypeOptions.map((option) => (
                                <th
                                    key={option?._id || option?.title?.en_US}
                                    style={{
                                        width: "105px",
                                        minWidth: "105px",
                                        maxWidth: "105px",
                                        whiteSpace: "normal",
                                        overflowWrap: "break-word",
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                        padding: "5px 6px",
                                    }}
                                >
                                    {option?.title?.en_US || "Untitled option"}
                                </th>
                            ))}

                            <th
                                style={{
                                    background: "#c20808",
                                    color: "#fff",
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                }}
                            >
                                Actionable Items
                            </th>
                            {metricFields.map((field) => (
                                <th
                                    key={field?._id || field?.title?.en_US}
                                    className="stats-action-header"
                                    style={{
                                        width: "100px",
                                        minWidth: "100px",
                                        maxWidth: "100px",
                                        whiteSpace: "normal",
                                        overflowWrap: "break-word",
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                        padding: "5px 6px",
                                    }}
                                >
                                    {field?.statistic_name ||
                                        field?.title?.en_US ||
                                        "Untitled metric"}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {Array.isArray(spreadsheetData?.rows) &&
                            spreadsheetData.rows.length > 0 ? (
                            <>
                                {spreadsheetData.rows.map((row) => (
                                    <tr key={row.key}>
                                        <td className="stats-sticky-col">
                                            {row.label}
                                        </td>

                                        {/* TOTAL INCIDENTS */}
                                        <td>{row.incident_count}</td>

                                        {/* RESOLVED INCIDENTS */}
                                        <td>{row.resolved_count}</td>

                                        {resolutionTypeOptions.map((option) => {
                                            const optionTitle =
                                                option?.title?.en_US || "Untitled option";

                                            return (
                                                <td
                                                    key={`${row.key}-${option?._id || optionTitle}`}
                                                >
                                                    {row?.resolution_types?.[optionTitle] || 0}
                                                </td>
                                            );
                                        })}

                                        {/* ACTIONABLE ITEMS DIVIDER */}
                                        <td className="stats-action-divider"></td>

                                        {metricFields.map((field) => {
                                            const metricKey =
                                                field?.key ||
                                                field?.statistic_name ||
                                                field?.title?.en_US;

                                            const normalizedKey = String(metricKey || "")
                                                .trim()
                                                .toLowerCase()
                                                .replace(/[^a-z0-9]+/g, "_")
                                                .replace(/^_+|_+$/g, "");

                                            return (
                                                <td
                                                    key={`${row.key}-${field?._id || normalizedKey}`}
                                                >
                                                    {row?.metrics?.[normalizedKey] || 0}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}

                                {/* TOTAL ROW */}
                                <tr
                                    style={{
                                        fontWeight: 700,
                                        background: "#e6e6e6",
                                    }}
                                >
                                    <td className="stats-sticky-col">
                                        Total
                                    </td>

                                    <td>{totalIncidents}</td>

                                    <td>{totalResolved}</td>

                                    {resolutionTypeOptions.map((option) => {
                                        const optionTitle =
                                            option?.title?.en_US || "Untitled option";

                                        const total = statsRows.reduce(
                                            (sum, row) =>
                                                sum +
                                                (Number(
                                                    row?.resolution_types?.[optionTitle]
                                                ) || 0),
                                            0
                                        );

                                        return (
                                            <td
                                                key={`total-${option?._id || optionTitle}`}
                                            >
                                                {total}
                                            </td>
                                        );
                                    })}

                                    {/* ACTIONABLE ITEMS DIVIDER */}
                                    <td className="stats-action-divider"></td>

                                    {metricFields.map((field) => {
                                        const metricKey =
                                            field?.key ||
                                            field?.statistic_name ||
                                            field?.title?.en_US;

                                        const normalizedKey = String(metricKey || "")
                                            .trim()
                                            .toLowerCase()
                                            .replace(/[^a-z0-9]+/g, "_")
                                            .replace(/^_+|_+$/g, "");

                                        const total = statsRows.reduce(
                                            (sum, row) =>
                                                sum +
                                                (Number(
                                                    row?.metrics?.[normalizedKey]
                                                ) || 0),
                                            0
                                        );

                                        return (
                                            <td
                                                key={`total-${field?._id || normalizedKey}`}
                                            >
                                                {total}
                                            </td>
                                        );
                                    })}
                                </tr>
                            </>
                        ) : (
                            <tr>
                                <td
                                    colSpan={resolutionTypeOptions.length + 10}
                                    style={{
                                        textAlign: "center",
                                        padding: 20,
                                        color: "#666",
                                    }}
                                >
                                    Run a report to view statistics.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default StatsReport;